import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { injectIntl, FormattedMessage } from "react-intl";

import * as auth from "../_redux/authRedux";
import * as schoolDUCK from "../../../../redux/ducks/school.duck";
import { useLogin } from "./hooks/useLogin";
import LoginStats from "./components/LoginStats";
import LoginButton from "./components/LoginButton";
import PhoneForm from "./components/PhoneForm";
import EmailForm from "./components/EmailForm";
import ValidationCodeInput from "./components/ValidationCodeInput";

function Login(props) {
  const {
    loading,
    wValidationCode,
    setWValidationCode,
    notSSO,
    enabled,
    formik,
    getInputClasses,
    isInvalidCombination,
    loginMethod,
    handleChangeLoginMethods,
  } = useLogin(props);

  return (
    <div className="d-flex flex-column justify-content-center align-items-center w-100 h-100 position-relative">
      <div className="login-form login-signin" id="kt_login_signin_form">
        <div id="recaptcha-container"></div>

        <div className="login-header mb-10 text-center">
          <h3 className="font-size-h1 mb-4">
            <FormattedMessage id="AUTH.LOGIN.TITLE" />
          </h3>
          <p className="text-muted font-weight-bold mb-0">
            Welcome (back) to The Zone Admin Portal
          </p>
        </div>

        {!notSSO && (
          <div className="d-flex justify-content-end">
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a
              className="text-dark-50 text-hover-primary"
              onClick={() => setWValidationCode(!wValidationCode)}
            >
              {wValidationCode ? "Login with SSO" : "Login with password"}
            </a>
          </div>
        )}

        <form
          noValidate
          autoComplete="off"
          onSubmit={formik.handleSubmit}
          className="form fv-plugins-bootstrap fv-plugins-framework"
          style={{ maxWidth: "300px", margin: "0 auto" }}
        >
          {formik.status && (
            <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible text-center">
              <div className="alert-text font-weight-bold">{formik.status}</div>
            </div>
          )}

          <div className="fv-plugins-icon-container">
            {(!loginMethod || loginMethod === "email") && (
              <EmailForm
                formik={formik}
                wValidationCode={wValidationCode}
                enabled={enabled}
                getInputClasses={getInputClasses}
              />
            )}
            {!wValidationCode && (
              <div
                style={{
                  margin: "10px auto",
                  color: "#B5B5C3",
                  textAlign: "center",
                  fontSize: "14px",
                }}
              >
                or
              </div>
            )}
            {(!loginMethod || loginMethod === "sms") && (
              <PhoneForm formik={formik} />
            )}
          </div>

          {loginMethod && (
            <ValidationCodeInput
              loginMethod={loginMethod}
              handleChangeLoginMethods={handleChangeLoginMethods}
              formik={formik}
            />
          )}

          <div className="form-group d-flex flex-wrap justify-content-center align-items-center">
            <LoginButton
              wValidationCode={wValidationCode}
              formik={formik}
              isInvalidCombination={isInvalidCombination}
              loading={loading}
            />
            {formik.values.email && formik.values.phoneNumber && (
              <div className="fv-help-block">
                You can only use one of the available login methods.
              </div>
            )}
          </div>
        </form>
      </div>
      <LoginStats />
    </div>
  );
}

const mapDispatchToProps = (dispatch) => ({
  setSelectedSchool: bindActionCreators(
    schoolDUCK.actions.setSelectedSchool,
    dispatch
  ),
  authActions: bindActionCreators(auth.actions, dispatch),
});

export default injectIntl(connect(null, mapDispatchToProps)(Login));
